import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { StorageService } from './storage.service';

@Injectable({
    providedIn: 'root'
})
export class LocalService {

    public sidebarEventSource = new BehaviorSubject<boolean>(false);

    constructor(private storageService: StorageService) { }

    open() {
        this.sidebarEventSource.next(true);
    }

    // Set the json data to local storage
    set(key: string, value: any) {
        this.storageService.setItem(this.storageService.hash(key), value);
    }

    // Get the json value from local storage
    get<T = any>(key: string) {
        return this.storageService.getItem<T>(this.storageService.hash(key));
    }

    // Remove the json value from local storage
    remove(key: string) {
        return this.storageService.removeItem(this.storageService.hash(key));
    }
	
    // Clear the local storage
    clearStorage() {
        this.storageService.clear();
    }
}
